import draggable from "vuedraggable";
import GeneralMixin from '../../mixin';
import ResourcesMixin from '@/app/shared/mixins/BaseResourcesGestaoMixin';

export default {
    mixins: [
        GeneralMixin,
        ResourcesMixin,
    ],
    components: {
        draggable,
        UploadMultipleImage: () => import(/* webpackChunkName: "upload-image" */ '@/components/form/UploadMultipleImage.vue'),
    },
    data() {
        return {
            form: {
                id: null,
            },
            legends: [],
        }
    },
    mounted() {
        this.loadLists();
        if(!this.form.id){
            this.startLoadResources=true;
        }
    },
    computed: {

    },
    methods: {
        loadLists: function() {

        },
        callbackLoadItem: function() {
            this.startLoadResources=true;
        },
    },
    watch: {

    },
};
